export { default as wrapRootElement } from './src/store';
